import {
  Box,
  FormHelperText,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import React, { ComponentType } from "react";

import { Option } from "./FieldProps";
import Text from "./Text";

type Toggle = Option & {
  LeftIcon?: ComponentType;
};

export type ToggleOptions = Toggle[];

interface ToggleProps<TFieldValue> {
  options: ToggleOptions;
  value: string | string[];
  exclusive?: boolean;
  onChange: (event: React.MouseEvent<HTMLElement>, value: TFieldValue) => void;
  errorMessage?: string;
  disabled?: boolean;
}

const ToggleGroup = <TFieldValue,>({
  options,
  exclusive,
  errorMessage,
  ...field
}: ToggleProps<TFieldValue>) => {
  return (
    <Box>
      <ToggleButtonGroup {...field} size="small" exclusive={exclusive}>
        {options.map(({ value, label, LeftIcon }) => (
          <ToggleButton key={value} value={value}>
            <Stack direction="row" alignItems="center" spacing={1}>
              {LeftIcon && <LeftIcon />}
              <Text variant="caption">{label}</Text>
            </Stack>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
    </Box>
  );
};

export default ToggleGroup;
